import { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Button } from '@habitech/call-to-action';
import { Container, LabelRow, ButtonWrapper } from './ImportHistory.styles';
import { Title } from '../styles';
import { getExportHistory, getHistory } from 'src/apis/exportHistoryForHabi';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import { filterMap, headerMap } from './importHistory.constant';
import { esES } from '@mui/x-data-grid/locales';

export const convertToCSV = (jsonData) => {
    const headers = Object.values(headerMap).join(',');
    const values = jsonData
        .map((item) => {
            return Object.keys(headerMap)
                .map((key) =>
                    item[key] !== null && item[key] !== undefined
                        ? `"${item[key]}"`
                        : '""'
                )
                .join(',');
        })
        .join('\n');

    return `${headers}\n${values}`;
};

export const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default function ImportHistory() {
    const token = useSelector((state: RootState) => state.User.token);
    const [recordList, setRecordList] = useState([]);
    const Filters = ({ params }) => {
        const filters = params.value;
        const filterString = Object.entries(filters).map(([key, value]) =>
            value ? (
                <div className="item" key={key}>
                    {`${filterMap[key]}: `}
                    <span>{`${value}`}</span>
                </div>
            ) : null
        );
        return <LabelRow>{filterString}</LabelRow>;
    };

    const ButtonDowloand = ({ id }) => (
        <ButtonWrapper>
            <Button
                dataId="btn"
                originType="pcom"
                variant="ghost"
                onClick={() => handleDownloadCSV(id)}
            >
                Descargar .CSV
            </Button>
        </ButtonWrapper>
    );

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1 },
        {
            field: 'export_date',
            headerName: 'Fecha exportación',
            width: 150,
            flex: 1,
        },
        {
            field: 'used_export_filters',
            headerName: 'Filtros usados',
            width: 550,
            renderCell: (params) => <Filters params={params} />,
        },
        {
            field: 'exported_properties_count',
            headerName: 'No. propiedades',
            width: 150,
            flex: 1,
        },
        {
            field: 'actions',
            headerName: 'Acción',
            width: 150,
            flex: 1,
            renderCell: ({ id }) => <ButtonDowloand id={id} />,
        },
    ];


    const handleDownloadCSV = async (id: number | string) => {
        try {
            const res = await getExportHistory({ token, id });
            const csvData = convertToCSV(res.result);
            downloadCSV(csvData, 'data.csv');
        } catch (e) {
            console.error('Error al exportar el .CSV', e);
        }
    };

    useEffect(() => {
        getHistory({ token }).then((res) => {
            setRecordList(res.result || []);
        });
    }, [token]);

    return (
        <Container>
            <Title>Histórico de Exportaciones</Title>
            <DataGrid
             localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                rows={recordList}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 5},
                    },
                }}
                pageSizeOptions={[5, 10, 25]}
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnMenu
                disableColumnSorting
                autoHeight
            />
        </Container>
    );
}
